const listaDeTarefas = (state) => {
    return state.items;
}

const listaDeTarefasAtivas = (state) => {
    return state.itemsAtivos;
}

const listaDeTipoAgings = (state) => {
    return state.tipoAgings
}

const listaDeTipoTarefas = (state) => {
    return state.tipoTarefas
}

const listaDeDadosDetalhados = (state) => {
    return state.dadosDetalhados
}

const loadingTarefas = (state) => {
    return state.carregando
}

const tarefaSelecionada = (state) => {
    return state.selecionado
}

const tarefaOpcaoTratativa = (state) => {
    return state.opcoesTratativas;
}

const tabIndex = (state) => {
    return state.tabIndex
}

const podeInativar = (state) => {
    return state.podeInativar;
}

export {
    listaDeTarefas,
    listaDeTarefasAtivas,
    listaDeTipoAgings,
    listaDeTipoTarefas,
    loadingTarefas,
    tarefaSelecionada,
    listaDeDadosDetalhados,
    tarefaOpcaoTratativa,
    tabIndex,
    podeInativar
}
